import Api from '@api/shou_xie/showCase'
import { isWeddingDressProperty } from '@merchant-backend/util'
import { isStoreAccount } from '@util'
import cloneDeep from 'lodash/cloneDeep'
import { action, observable, runInAction } from 'mobx'

class Store {
  constructor(mainStore) {
    this.mainStore = mainStore
  }
  selectList = [
    {
      title: '套餐',
      type: 'meal'
    },
    // {
    //   title: '案例',
    //   type: 'case'
    // },
    {
      title: isStoreAccount() ? '新商品管理' : '套餐列表',
      type: 'mealList'
    },
    {
      title: '私信',
      type: 'talk'
    }
  ]

  @observable tablist = []

  @action
  setTabList() {
    let list = [].concat(this.selectList)
    if (this.activeTab === 'case' || !isWeddingDressProperty()) {
      list.splice(1, 0, {
        title: '案例',
        type: 'case'
      })
    }
    this.tablist = list
  }

  @observable editId = '' // 当前id
  @observable activeTab = 'meal'
  @observable
  checkedValue = {
    id: '',
    type: '',
    info: ''
  }
  @observable conList = [] // 套餐列表
  @observable caseList = [] // 案例列表
  // 套餐列表分页
  @observable
  paginationTest = {
    showQuickJumper: true,
    showTotal: total => `共 ${total} 条`,
    showSizeChanger: true,
    current: 1,
    pageSize: 6,
    total: 0
  }
  // 案例列表分页
  @observable
  paginationCase = {
    showQuickJumper: true,
    showTotal: total => `共 ${total} 条`,
    showSizeChanger: true,
    current: 1,
    pageSize: 6,
    total: 0
  }
  @action
  onConChange = page => {
    this.paginationTest.current = page
    this.getConList(page)
  }
  @action
  onCaseChange = page => {
    this.paginationCase.current = page
    this.getCaseList(page)
  }
  @action
  handleChangeTab = type => {
    runInAction(() => {
      this.activeTab = type
    })
  }
  @action
  handleCheckItem = (value, type, id, info) => {
    runInAction(() => {
      this.checkedValue = value
        ? {
            id,
            type,
            info
          }
        : {
            id: '',
            type: '',
            info: ''
          }
    })
  }
  init = () => {
    this.getConList()
    this.getCaseList()
    this.getSelectedInfo()
  }
  /**
   * 套餐列表
   */
  @action
  getConList = async (page = this.paginationTest.current) => {
    this.loading = true

    const params = {
      page: page,
      per_page: 6,
      is_sold_out: 0,
      commodity_type: 0,
      status: 1
    }

    const {
      data: { list, total_count },
      success
    } = await Api.setMealListApi(params)

    runInAction(() => {
      if (success) {
        this.conList = list || []
        this.paginationTest.total = total_count * 1
        this.loading = false
      }
    })
  }
  /**
   * 案例列表
   */
  @action
  getCaseList = async (page = this.paginationCase.current) => {
    this.loading = true

    const params = {
      page: page,
      per_page: 6,
      is_sold_out: 0,
      commodity_type: 1,
      status: 1
    }

    const {
      data: { list, total_count },
      success
    } = await Api.setMealListApi(params)

    runInAction(() => {
      if (success) {
        this.caseList = list || []
        this.paginationCase.total = total_count * 1
        this.loading = false
      }
    })
  }
  /**
   * 获取选中的数据
   */
  getSelectedInfo = () => {
    const photoIndex = this.mainStore.photoIndex
    const info =
      photoIndex === 'TOP'
        ? cloneDeep(this.mainStore.selectedInfoUp)
        : cloneDeep(this.mainStore.selectedInfoDown)

    const typeNumber =
      photoIndex === 'TOP'
        ? this.mainStore.selectedTypeUp
        : this.mainStore.selectedTypeDown
    const type = this.resetSelectType(typeNumber)

    runInAction(() => {
      this.checkedValue = {
        info,
        type,
        id: info.id
      }
      this.activeTab = type || 'meal'
    })
  }
  @action
  handleOk = () => {
    this.mainStore.setMealShow = false
    switch (this.mainStore.photoIndex) {
      case 'TOP':
        this.mainStore.selectedInfoUp = this.checkedValue.info
        this.mainStore.selectedTypeUp = this.getSelectType(
          this.checkedValue.type
        )
        return
      case 'BOTTOM':
        this.mainStore.selectedInfoDown = this.checkedValue.info
        this.mainStore.selectedTypeDown = this.getSelectType(
          this.checkedValue.type
        )
        return
    }
  }
  @action
  handleCancel = () => {
    this.mainStore.setMealShow = false
    this.checkedValue = {
      id: '',
      type: '',
      info: ''
    }
  }
  getSelectType = type => {
    switch (type) {
      case 'meal':
        return 15
      case 'case':
        return 14
      case 'mealList':
        return 267
      case 'talk':
        return 99
    }
  }
  resetSelectType = type => {
    switch (+type) {
      case 15:
        return 'meal'
      case 14:
        return 'case'
      case 267:
        return 'mealList'
      case 99:
        return 'talk'
    }
  }
}
export default Store
